import { useEffect } from 'react';

import { Navigate, useTypedParams } from '@sorare/routing';

import { ANY_SPORT_MY_CIRCLES_EVENTTYPE_FIXTURE_SLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';

import type { PageParams } from './__generated__/routeParams';
import { useLayoutData } from './layout';

const MyCircleFixturePage = () => {
  const track = useEvents();
  const isDesktopAndAbove = useIsDesktopAndAbove();
  const { generateSportContextPath } = useSportContext();

  const { fixture, eventType } = useTypedParams<PageParams>();

  const { firstUserSlug } = useLayoutData();

  useEffect(() => {
    track('View My Circles Screen', {});
  }, [track]);

  if (firstUserSlug && isDesktopAndAbove) {
    return (
      <Navigate
        to={generateSportContextPath(
          ANY_SPORT_MY_CIRCLES_EVENTTYPE_FIXTURE_SLUG,
          {
            params: {
              slug: firstUserSlug,
              fixture,
              eventType,
            },
          }
        )}
        replace
      />
    );
  }
  return null;
};

export default MyCircleFixturePage;
